import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const FinanceData = ({ summaryCards }) => {
  const { t } = useTranslation();

  const data = [
    {
      key: "totalBookings",
      label: t("finance.stats.totalBookings", "Total Bookings"),
      value: summaryCards?.totalBookings || 0,
      bgColor: "#E3F2FD", // light blue
    },
    {
      key: "sales",
      label: t("finance.stats.sales", "Total Revenue"),
      value: summaryCards?.sales || 0,
      bgColor: "#E8F5E9", // light green
    },
    {
      key: "cancellations",
      label: t("finance.stats.cancellations", "Cancellations"),
      value: summaryCards?.cancellations || 0,
      bgColor: "#FFF3E0", // light orange
    },
    {
      key: "payoutDue",
      label: t("finance.stats.payoutDue", "Payout Due"),
      value: summaryCards?.payoutDue || 0,
      bgColor: "#F3E5F5", // light purple
    },
    {
      key: "paidThisPeriod",
      label: t("finance.stats.paidThisPeriod", "Paid This Period"),
      value: summaryCards?.paidThisPeriod || 0,
      bgColor: "#E0F7FA", // light cyan
    },
    {
      key: "outstanding",
      label: t("finance.stats.outstanding", "Outstanding"),
      value: summaryCards?.outstanding || 0,
      bgColor: "#FFFDE7", // light yellow
    },
  ];

  return (
    <Row>
      {data.map((item, index) => (
        <Col key={index} lg={4} md={6} sm={12} className="my-2">
          <div
            className="cardCstm rounded p-3 py-lg-4 d-flex align-items-center justify-content-between"
            style={{
              background: item.bgColor,
              borderRadius: "12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              transition: "all 0.3s ease",
            }}
          >
            <div className="content text-center w-100">
              <h6
                className="m-0 fw-semibold text-secondary"
                style={{ fontSize: "15px" }}
              >
                {item.label}
              </h6>
              <h3
                className="m-0 fw-bold text-dark mt-2"
                style={{ fontSize: "20px" }}
              >
                {item.value.toLocaleString()}
              </h3>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default FinanceData;
